module.exports = __webpack_public_path__ + "img/shooting_02.a081cfec.jpg";